




































































































































































import Vue from 'vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { MStoreForm } from '@/components/shared';
import { ScriveSettingsModel, StoreConstants, ValueType } from '@/types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import { ValidationModel } from '@/types/models/validation';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import { confirmationHelper, FormFieldValidation } from '@/mixins';
import { mapGetters } from 'vuex';
import MStoreFormGroup from '@/components/shared/MStoreFormGroup.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'ScriveSettings',
  mixins: [confirmationHelper, FormFieldValidation],
  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      isDocumentTypeLoading: false,
      scriveSettings: {} as ScriveSettingsModel,
      documentTypeId: 0
    };
  },
  computed: {
    ...mapGetters(StoreConstants.ApplicationDirty.ModuleName, [StoreConstants.ApplicationDirty.Getters.IsApplicationDirty]),
    expireAfterDays: {
      get(this: any) {
        return this.scriveSettings.expireAfterDays;
      },
      set(this: any, value: string) {
        Vue.set(this.scriveSettings, 'expireAfterDays', Boolean(value) ? Number(value) : value);
      }
    },
    remindAfterDays: {
      get(this: any) {
        return this.scriveSettings.remindAfterDays;
      },
      set(this: any, value: string) {
        Vue.set(this.scriveSettings, 'remindAfterDays', Boolean(value) ? Number(value) : value);
      }
    },
    remindAfterDaysValidation(this: any) {
      return this.scriveSettings.remindersEnabled
        ? ({
            ...this.DAYS_VALIDATION,
            lessThanField: { maxValueFieldName: 'ExpireAfterDays', maxValue: this.expireAfterDays }
          } as ValidationModel)
        : null;
    }
  },
  methods: {
    async onCancel(this: any, dirty: boolean) {
      try {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, dirty);
        if (hasUnsavedChangesToKeep) {
          return;
        }
        this.isLoading = true;
        this.setApplicationDirty(false);
        await this.getScriveSettings(this.documentTypeId);

        this.isLoading = false;
      } catch (error) {
        this.$log('failed to confirm unsaved changes');
        return false;
      }
    },
    async getScriveSettings(this: any, documentTypeId?: number) {
      this.isLoading = true;
      this.hasError = false;
      this.resetValidation();

      try {
        const scriveSettingsConfiguration = await ScriveConfigurationService.getSettingsConfigurationAsync(documentTypeId);
        this.DOCUMENT_TYPES = scriveSettingsConfiguration.documentTypes;
        this.documentTypeId = scriveSettingsConfiguration.documentTypeId;
        this.scriveSettings = scriveSettingsConfiguration.settings;
        this.resetValidation();
      } catch (error) {
        this.$validator.errors.add({
          field: FormFieldValidation.Constants.FormsValidationErrorsField,
          msg: error.notification
        });
      } finally {
        this.isLoading = false;
      }
    },
    async saveScriveSettings() {
      this.isSubmitting = true;
      try {
        await ScriveConfigurationService.addUpdateSettingsConfigurationAsync(this.documentTypeId, this.scriveSettings);
        SnotifyConfiguration.showSuccess('Settings updated successfully.');
      } catch (err) {
        this.$log(err);
      }
      this.isSubmitting = false;
    },
    async updateDocumentType(this: any, documentTypeId: number) {
      const currentDocumentTypeId = this.documentTypeId;
      this.documentTypeId = documentTypeId;
      if (await this.hasUnsavedChangesToKeepAsync(this.$bvModal, this.isApplicationDirty)) {
        this.documentTypeId = currentDocumentTypeId;
        return;
      }
      this.isDocumentTypeLoading = true;
      await this.getScriveSettings(documentTypeId);
      this.isDocumentTypeLoading = false;
    },
    resetValidation(this: any) {
      this.$validator.reset();
      this.resetFormValidation();
      this.$data._formDirty = false;
    }
  },
  async mounted(this: any) {
    await this.getScriveSettings();
    this.isLoading = false;
    this.resetValidation();
  },
  created(this: any) {
    this.DAYS_VALIDATION = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 0,
      maxValue: 365
    } as ValidationModel;
  },
  components: { MStoreSpinnerButton, MStoreForm, LoadingSpinner, MStoreFormInput, MStoreFormGroup }
});
